import { Component, Input, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { Attribute } from '~app/modules/filters/models';
import { AttributeOption } from '~shared/models';
import { BrandsService } from '~app/modules/storyblok/services';
import { RegionSelectorService } from '~shared/modules/region-selector/services';
import { FILTER_ATTRIBUTE_KEYS } from '~app/modules/filters/constants';
import { NUMBER_10, NUMBER_5, NUMBER_6 } from '~shared/constants';

@Component({
  selector: 'app-brand-list-wrapper',
  templateUrl: './brand-list-wrapper.component.html',
})
export class BrandListWrapperComponent implements OnInit {
  @Input() limit: number = NUMBER_10;
  isMobile: boolean = false;
  brands: Array<AttributeOption> = [];
  readonly minimumBrands: number = NUMBER_5;

  private unsubscribe$ = new Subject();

  constructor(
    private brandsService: BrandsService,
    private mediaObserver: MediaObserver,
    private regionSelectorService: RegionSelectorService
  ) {}

  ngOnInit(): void {
    this.initializeRegionObserver();
    this.initializeMediaObservable();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initializeRegionObserver(): void {
    this.regionSelectorService.userRegion$.subscribe(() => {
      this.loadBrandList();
    });
  }

  private loadBrandList(): void {
    const categorySlug = this.getPageSlug();

    this.brandsService
      .getBrandsByCategorySlug(categorySlug)
      .pipe(
        takeUntil(this.unsubscribe$),
        map((attributes: Attribute[]) =>
          attributes.find((attribute: Attribute) => attribute.id === FILTER_ATTRIBUTE_KEYS.BRAND)
        )
      )
      .subscribe((brandsAttribute: Attribute) => {
        this.brands = brandsAttribute?.options?.filter((brand) => brand.value !== 'null');
      });
  }

  private getPageSlug(): string {
    return window?.location?.pathname?.split('/').pop() || '';
  }

  private initializeMediaObservable(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
      });
  }
}
